module.exports = __webpack_public_path__ + "static/media/30-13.e5ea35e6.mp3";